import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UtilsService} from '../appSharedModule/services/utils.service';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class LoaService {

  constructor(private httpClient: HttpClient, private utilsService: UtilsService) {
  }

  loadLoaContactsList(loaContactsUrl, email) {
    return this.utilsService.cacheableObservable(() => this.httpClient.get<any>(loaContactsUrl),
      'companiesList__' + email, true);
  }

  loadClientList(userImpersonatedId) {
    const companyUrl = environment.baseUrlWs + '/api/clients-dropdown-loa';
    return this.utilsService.cacheablePromise(() => firstValueFrom(this.httpClient.get<any>(companyUrl)),
      'companiesDropDown__' + userImpersonatedId,
      true);
  }

  deleteLoaContact(deletedContactId) {
    return this.httpClient.delete(environment.baseUrlWs + '/api/loa-contacts/' + deletedContactId);
  }

  addLoaContact(loaContact) {
    return this.httpClient.post(environment.baseUrlWs + '/api/loa-contacts', loaContact, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }

}
